import { render } from "./Label.vue?vue&type=template&id=25df9e93&scoped=true"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"

import "./Label.vue?vue&type=style&index=0&id=25df9e93&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-25df9e93"

export default script